import { CSV_TRANSLATIONS } from "./csvTranslations.generated";

export function normalizeKey(text) {
  return String(text ?? "")
    .trim()
    .replace(/^\d+\)\s*/, "")
    .replace(/[“”]/g, '"')
    .replace(/[’‘]/g, "'")
    .replace(/\s+/g, " ")
    .replace(/\s*\/\s*/g, "/")
    .replace(/Select one option only\.?/g, "Select one only.");
}

function translateFromMap(map, text) {
  const raw = String(text ?? "");
  const normalized = normalizeKey(raw);
  return map?.[normalized] ?? raw;
}

export function translateDiagnostic(lang, text) {
  const map = CSV_TRANSLATIONS?.diagnostic?.[lang];
  return translateFromMap(map, text);
}

export function translateResults(lang, text) {
  const map = CSV_TRANSLATIONS?.results?.[lang];
  return translateFromMap(map, text);
}
